<div class="modal-docs-content unsuccess-request-modal modal-body no-margin-top">  
  <div class="modal-block margin-top mt16 text-center">
      <div>
          <img src="./assets/img/images/icon-warning.svg" alt="warning icon" />
        </div>
      <div class="bigger-font-size margin-top mt16">
        <div> {{ 'TRY_AGAIN_LATER' | translate }} </div>
      </div>
      <div class="margin-top mt16 col-2d373d fs-16 lh-normal">
        {{ "PROBLEM_WITH_SUBMISSION" | translate }}
      </div>
  </div>

  <div class="contact-info-container margin-top mt32 text-center lh-normal">
      <div class="font-weight-500">
        {{ "IF_NEED_IMMEDIATE_ASSISTANCE" | translate }}
        <a routerLink='/contact' class="see-dec nobr">{{ "contact us here" }}</a>, or call:
      </div>

      <div class="mt-4 font-weight-500">
          Phone:<a href="tel:18556273737" class="mapfre link underline red-link req-unsucess-phone">1-855-627-3737</a>
      </div> 
      <div class="contact-schedule mt15 mb5">
          {{ 'MONDAY_FRIDAY_EST' | translate }}
      </div>
      <div class="contact-schedule">{{ 'SATURDAY_EST' | translate }}</div>      
  </div>

  <hr class="margin-top mt32 mb-2 col-E8EBED" />

  <div class="row text-right pt-4">
      <div class="col show-btn-order">
          <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn no-border mt-0'"
              [iconClasses]="'align-middle'" 
              (click)="tryAgain(false)">
              {{ 'Go to billing' }}
          </mapfre-button>
          <mapfre-button [additionalClasses]="'basic primary small-btn modal-small-btn pl-5 pr-5'"
              (click)="tryAgain(true)">
              {{ 'TRY_AGAIN' | translate }}</mapfre-button>
      </div>
  </div>
</div>